module.exports = __webpack_public_path__ + "img/1.a1d0bb11.jpg";